module.exports = __webpack_public_path__ + "img/MSTART-default-front.199da1bb.jpg";